import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import FieldCheckBox from '../../components/plain/FieldCheckBox';
import FieldString from '../../components/plain/FieldString';
import FieldReference from '../../components/plain/FieldReference';
import FieldList_Reference from '../../components/plain/FieldList_Reference';
import FieldList_TableGroup from '../../components/plain/FieldList_TableGroup';

import {FORM_TOPIC_PLAIN, FORM_TOPIC_TABLE} from '../../util/consts/forms';
import { CLASS_TOPIC } from '../../util/consts/classes';
import { TOPIC_PLAIN_PATH } from '../../util/routes';
//import { ENUMERATION_LANGUAGE, } from '../../util/consts/common';

class TopicPlainPage extends PlainPage {
	
	constructor(props) {
		super(props);
		this.formPath = FORM_TOPIC_PLAIN;
		this.formTitle = 'Тема';
		this.buildInstanceCard = this.buildTopicCard;
	}
	componentDidMount = async () => {
		this.init(CLASS_TOPIC)
		document.title = 'BOM. ' + this.formTitle;
	}
	async completeInit() {
//		this.enumLanguage = this.realm.getEnumeration( ENUMERATION_LANGUAGE );
		
		return true;
	}
	buildTopicCard = (topicInstance) => {
		let card = topicInstance.rootField.value.card.value;
		return card;
	}

	renderBody() {
		let readOnly = this.instanceReadOnly;
		let instance = this.state.instance;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldCheckBox instance={instance} path={'/isRoot'} plain={this}
							styles={{ divMain: { marginRight: '20px'} }}
							readOnly={readOnly}
						/>
						<FieldString instance={instance} path={'/code'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {width: '100px', marginRight: '20px'} }}
						/>
						<FieldReference instance={instance} path={'/classifierRef'} plain={this} 
							readOnly={readOnly}
							refNodes = {[
								{
									classId: CLASS_TOPIC, plainFormPath: TOPIC_PLAIN_PATH, 
									selectInstanceFormId: FORM_TOPIC_TABLE,
									selectInstanceFormTitle: 'Теми'
								}
								
							]}
							styles={{ divMain: {flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'/added'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {width: '100px', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'/modified'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {width: '100px'} }}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldList_TableGroup instance={instance} path={'/names'} plain={this} 
							plainDirtyCounter={this.state.plainDirtyCounter}
							readOnly={readOnly} 
							table={{
								columns: [
									{ columnId: 'language', styles: {tdHeader: {width: '15%'}} }, 
									{ columnId: 'name', styles: {tdHeader: {width: '40%'}} },
									{ columnId: 'notes', styles: {tdHeader: {width: '45%'}} },
								],
							}}
							styles={{
								divMain: {width: '150%'},
								table: {width: '100%'},
								trHeader: {height: '43px'}
							}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldList_Reference path={'/parents'} instance={instance} plain={this} 
							labelEmptyToHeader={true} readOnly={readOnly}
							refNodes = {[
								{
									classId: CLASS_TOPIC, plainFormPath: TOPIC_PLAIN_PATH, 
									selectInstanceFormId: FORM_TOPIC_TABLE,
									selectInstanceFormTitle: 'Теми'
								}
							]}
						/>
					</div>
				</div>
			</div>
		);
	}	
}

export default TopicPlainPage;
